import { k as jsxRuntimeExports } from "./doenetml-a_KitGQm.js";
import React__default from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-Ca2HvWV4.js";
const ndash = React__default.memo(function Ndash(props) {
  let { SVs } = useDoenetRenderer(props);
  if (SVs.hidden) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: "–" });
});
export {
  ndash as default
};
